/**
 * Everything brand-specific — palette, mark, wordmark, copy, assets — resolves
 * from here, so no screen ever hardcodes a colour or a name.
 */
export interface Brand {
  readonly id: string
  /** Lowercase wordmark as it is set in the lockup. */
  readonly wordmark: string
  /** Capitalised name for prose and the document title. */
  readonly name: string
  readonly tagline: string
  readonly description: string
  /** Asset path inside the R2 bucket. */
  readonly mark: string
  /** Width ÷ height of the mark, so the lockup never distorts. */
  readonly markRatio: number
  readonly authPanel: string
  readonly authHeadline: string
  readonly authSubhead: string
  readonly themeColor: string
  /** Email domain used in mock data and placeholders. */
  readonly domain: string
}

export const BRAND: Brand = {
  id: 'white1',
  wordmark: 'white1',
  name: 'White1',
  tagline: 'your money, first class',
  description:
    'Spend, send and hold dollars from one account. Local details in four currencies, a white card that works everywhere, and a price you can read.',
  mark: 'white1/mark.svg',
  markRatio: 64 / 120,
  authPanel: 'white1/auth-panel.jpg',
  authHeadline: 'Your money, first class.',
  authSubhead:
    'Dollars, euros, pesos and reais in one account, and a white card that costs nothing until you activate it.',
  themeColor: '#0b0d12',
  domain: 'white1.com',
}
